import { maxLength, required } from '@seek/validators-js';
import { TextField } from 'braid-design-system';
import { format } from 'date-fns/format';
import { useField } from './form.tsx';
import { displayNameForDataType } from '#src/utils/credentials.ts';

interface Props {
  disabled: boolean;
  id: string;
  showLabel: boolean;
  dataType: 'live' | 'publicTest';
}

export const NameField = ({ disabled, id, showLabel, dataType }: Props) => {
  const name = useField<'name', { max: number; requiredLabel: string }>({
    id: 'name',
    validators: [required, maxLength],
    validatorProps: { max: 32, requiredLabel: 'a name' },
  });

  return (
    <TextField
      {...(showLabel
        ? {
            label: 'Name',
            description:
              'Give your credentials a descriptive name for your own reference later.',
            placeholder: `e.g. SEEK API - ${displayNameForDataType(dataType)} - ${format(new Date(), 'yyyy-MM-dd')}`,
          }
        : { 'aria-label': 'Name' })}
      characterLimit={32}
      disabled={disabled}
      id={id}
      message={name.errorMessage}
      onBlur={name.onBlur}
      onChange={name.onChange}
      tone={name.valid ? undefined : 'critical'}
      value={name.value}
    />
  );
};
